<template>
  <div class="popup">
    <div class="popup-header"><NavHeader @close-modal="closePopup" /></div>
    <div class="popup-content">
      <slot name="content" />
    </div>

    <div class="popup-footer">
      <div class="popup-footer_copyright">© 2022. Carbon Finance | Terms</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import NavHeader from '@/components/header/index.vue'
const emit = defineEmits<{
  (e: 'close-popup'): void
}>()
const closePopup = () => {
  return emit('close-popup')
}
</script>
